(() => {
  const form = document.getElementById('cart_form');
  if (!form) return;
  const quote = form.querySelector('.sf-cart-preview');
  const country = document.getElementById('sf-cart-country');
  if (quote && country) {
    const update = () => {
      const code = country.value.toLowerCase();
      const supported = (code === 'de' || code === 'at') && quote.dataset.currency === 'EUR';
      quote.querySelector('[data-sf-shipping]').textContent = supported ? quote.dataset[code + 'Shipping'] : quote.dataset.unknown;
      quote.querySelector('[data-sf-total]').textContent = supported ? quote.dataset[code + 'Total'] : quote.dataset.unknown;
    };
    country.addEventListener('change', update);
    update();
  }
  const agree = document.getElementById('agree');
  const error = document.getElementById('sf-cart-terms-error');
  const express = form.querySelector('[data-sf-express]');
  const expressHint = form.querySelector('[data-sf-express-hint]');
  const updateExpress = () => {
    if (!express) return;
    const enabled = !agree || agree.checked;
    express.hidden = !enabled;
    if (enabled) express.removeAttribute('inert');
    else express.setAttribute('inert', '');
    if (expressHint) expressHint.hidden = enabled;
  };
  updateExpress();
  if (agree) agree.addEventListener('change', updateExpress);
  if (!agree || !error) return;
  const validate = event => {
    if (agree.checked) return true;
    event.preventDefault();
    error.hidden = false;
    agree.setAttribute('aria-invalid', 'true');
    agree.focus();
    error.scrollIntoView({ block: 'nearest' });
    return false;
  };
  form.querySelectorAll('[name="checkout"],[name="goto_pp"],[name="goto_gc"]').forEach(button => button.addEventListener('click', validate));
  form.addEventListener('submit', event => {
    if (['checkout', 'goto_pp', 'goto_gc'].includes(event.submitter?.name)) validate(event);
  });
  agree.addEventListener('change', () => {
    if (agree.checked) {
      error.hidden = true;
      agree.removeAttribute('aria-invalid');
    }
  });
})();

